import React from 'react'
import { styled } from '@mui/material/styles'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import Grid from '@mui/system/Grid'
import { Box, Container } from '@mui/material';

// 7.1 passed props to received in hook useAdminPanel[6.0]
// const AdminProfileData = ({adminProfile, studentsRecords, adminLogout}) => {
  // =============== OR =================== //
  const AdminProfileData = (props)  => {
  // console.log("AdminProfileData props:", props);
  // console.log("adminProfile:", props.adminProfile);
  // console.log("studentsRecords:", props.studentsRecords);
  // console.log("Type of studentsRecords:", typeof props.studentsRecords);
  
  // Destructure after checking
  const {studentsRecords, adminLogout } = props || {}
  

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: '#e17055',
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }))
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  }))
  return (
    <Container
      maxWidth="lg"
      className="parentdiv registerusers"
      sx={{ marginBottom: '40px' }}
    >
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            md={12}
            className="heading"
            sx={{ textAlign: 'center' }}
          >
            <h1>All Registered Students - Enrollment Data</h1>
          </Grid>

          

          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 700 }} aria-label="customized table">
              <TableHead>
                <TableRow>
                  <StyledTableCell>Sr.No</StyledTableCell>
                  <StyledTableCell>Full Name</StyledTableCell>
                  <StyledTableCell>Gender</StyledTableCell>
                  <StyledTableCell>Mobile</StyledTableCell>
                  <StyledTableCell>Email</StyledTableCell>
                  <StyledTableCell>Date of Birth</StyledTableCell>
                  <StyledTableCell>Board</StyledTableCell>
                  <StyledTableCell>Grade</StyledTableCell>
                  <StyledTableCell>Edit</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {Object.entries(studentsRecords).map(([key, user], index) => (
                
                  <StyledTableRow key={index}>
                    <StyledTableCell>{index + 1}</StyledTableCell>
                    <StyledTableCell>
                      <input
                        type="text"
                        value={user.fullname}
                        placeholder={user.fullname}
                        disabled
                      />
                    </StyledTableCell>
                    <StyledTableCell>{user.gender}</StyledTableCell>
                    <StyledTableCell>{user.mobile}</StyledTableCell>
                    <StyledTableCell>{user.email}</StyledTableCell>
                    <StyledTableCell>{user.dob}</StyledTableCell>
                    <StyledTableCell>{user.board}</StyledTableCell>
                    <StyledTableCell>{user.grade}</StyledTableCell>
                    <StyledTableCell>
                      <span>
                        <button id="edit">
                          <box-icon name="edit"></box-icon>
                        </button>
                      </span>
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Box>
    </Container>
  )
}

export default AdminProfileData
